module.exports = __webpack_public_path__ + "img/90.5.COD.a04e0abc.png";